import React from 'react';
import styled from 'styled-components';
import { SpaceProps } from 'styled-system';
import { ClickableBox } from './Box';

interface ArrowProps {
  color: string;
  size?: number;
  onClick?(): any;
  disabled?: boolean;
}

const ArrowBox = styled(ClickableBox)`
  width: 0;
  height: 0;
  margin-left: 4px;
`;

export const ArrowUp: React.FC<ArrowProps & SpaceProps> = ({ color, size = 8, ...rest }) => {
  return (
    <ArrowBox
      borderLeft={`${size}px solid`}
      borderLeftColor="transparent"
      borderRight={`${size}px solid`}
      borderRightColor="transparent"
      borderBottom={`${size * 2}px solid`}
      borderBottomColor={color}
      {...rest}
    />
  );
};

export const ArrowDown: React.FC<ArrowProps & SpaceProps> = ({ color, size = 8, ...rest }) => {
  return (
    <ArrowBox
      borderLeft={`${size}px solid`}
      borderLeftColor="transparent"
      borderRight={`${size}px solid`}
      borderRightColor="transparent"
      borderTop={`${size * 2}px solid`}
      borderTopColor={color}
      {...rest}
    />
  );
};
